// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * 가족 정보 변경 - Safari Adventure 태블릿 가로 모드
 * 주렁주렁 세계관 반영: 따뜻한 크림 배경 + 사파리 액센트
 */

/* === CSS Variables === */
:root {
  --fm-bg: #FFF8E1;
  --fm-card: #fff;
  --fm-primary: #2E7D32;
  --fm-primary-light: #E8F5E9;
  --fm-accent: #FF9800;
  --fm-accent-light: #FFF3E0;
  --fm-gold: #FFB300;
  --fm-text: #333;
  --fm-text-sub: #777;
  --fm-danger: #D32F2F;
  --fm-danger-light: #FFEBEE;
  --fm-edit-blue: #1E88E5;
  --fm-edit-blue-light: #E3F2FD;
  --fm-radius: 14px;
  --fm-shadow: 0 2px 12px rgba(0,0,0,0.07);
}

/* === 페이지 === */
.fm-page {
  height: 100dvh;
  background: var(--fm-bg);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  font-family: 'Noto Sans KR', sans-serif;
}

.fm-page button,
.fm-page input,
.fm-page select {
  min-height: auto;
}

/* === 헤더 === */
.fm-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 20px;
  background: rgba(255,255,255,0.92);
  backdrop-filter: blur(10px);
  border-bottom: 2px solid #FFE0B2;
  flex-shrink: 0;
}

.fm-header .btn-back {
  background: none;
  border: 2px solid #FF9800;
  color: #E65100;
  padding: 6px 14px;
  border-radius: 20px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;
}

.fm-header .btn-back:active {
  background: #FFF3E0;
}

.fm-header-center {
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  -webkit-tap-highlight-color: transparent;
}

.fm-header h1 {
  font-family: 'Jua', sans-serif;
  font-size: 22px;
  color: var(--fm-primary);
  margin: 0;
}

.fm-header-spacer {
  width: 72px;
}

/* === 콘텐츠 === */
.fm-content {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 12px 24px;
  overflow-y: auto;
}

/* === 검색 섹션: 좌우 배치, 높이 채우기 === */
.fm-search-section {
  width: 100%;
  flex: 1 1;
  display: flex;
  gap: 20px;
  align-items: stretch;
}

.fm-search-label {
  font-family: 'Jua', sans-serif;
  font-size: 15px;
  color: var(--fm-accent);
  margin: 0 0 8px;
  text-align: center;
  letter-spacing: 0.5px;
}

/* 전화번호 검색 */
.fm-phone-search {
  flex: 1 1;
  background: var(--fm-card);
  border-radius: var(--fm-radius);
  padding: 16px;
  box-shadow: var(--fm-shadow);
  border: 1px solid #FFE0B2;
  display: flex;
  flex-direction: column;
}

.fm-phone-display {
  padding: 10px;
  background: var(--fm-accent-light);
  border: 2px solid #FFE0B2;
  border-radius: 10px;
  font-size: 22px;
  font-family: 'Jua', sans-serif;
  font-weight: 600;
  text-align: center;
  letter-spacing: 3px;
  color: var(--fm-text);
  margin-bottom: 8px;
}

.fm-phone-display:empty,
.fm-phone-display:not(:empty) {
  color: var(--fm-text);
}

.fm-phone-search .fm-phone-display {
  color: var(--fm-text);
}

.fm-phone-error {
  text-align: center;
  color: var(--fm-danger);
  font-size: 13px;
  font-weight: 600;
  margin-bottom: 6px;
}

/* 넘버패드 */
.fm-numpad {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: repeat(4, 1fr);
  gap: 5px;
  margin-bottom: 8px;
  flex: 1 1;
}

.fm-numpad-btn {
  padding: 0;
  font-size: 22px;
  font-family: 'Jua', sans-serif;
  font-weight: 600;
  background: var(--fm-card);
  border: 1.5px solid #E0E0E0;
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.12s;
  -webkit-tap-highlight-color: transparent;
  -webkit-user-select: none;
          user-select: none;
}

.fm-numpad-btn:active {
  background: var(--fm-primary-light);
  border-color: var(--fm-primary);
  transform: scale(0.95);
}

.fm-numpad-clear {
  font-size: 12px;
  font-weight: 600;
  color: var(--fm-danger);
  background: var(--fm-danger-light);
  border-color: #EF9A9A;
}

.fm-numpad-clear:active {
  background: #FFCDD2;
  border-color: #E57373;
}

.fm-numpad-backspace {
  font-size: 20px;
  color: #666;
  background: #F5F5F5;
  border-color: #BDBDBD;
}

.fm-numpad-backspace:active {
  background: #E0E0E0;
}

/* 검색 버튼 */
.fm-phone-btn {
  width: 100%;
  padding: 14px;
  flex-shrink: 0;
  background: var(--fm-accent);
  color: #fff;
  border: none;
  border-radius: 10px;
  font-size: 17px;
  font-weight: 700;
  font-family: 'Jua', sans-serif;
  cursor: pointer;
  transition: all 0.15s;
  box-shadow: 0 2px 8px rgba(255,152,0,0.3);
}

.fm-phone-btn:disabled {
  opacity: 0.35;
  cursor: not-allowed;
  box-shadow: none;
}

.fm-phone-btn:not(:disabled):active {
  transform: scale(0.97);
  box-shadow: 0 1px 4px rgba(255,152,0,0.3);
}

/* 구분선 */
.fm-divider {
  display: none;
}

/* QR 섹션 */
.fm-qr-section {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: var(--fm-card);
  border-radius: var(--fm-radius);
  padding: 14px;
  box-shadow: var(--fm-shadow);
  border: 1px solid #FFE0B2;
}

.fm-qr-section .qr-scanner {
  max-width: 100%;
  width: 100%;
}

.fm-qr-section .qr-scanner-viewport {
  aspect-ratio: 1;
}

/* === 로딩 === */
.fm-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 14px;
  margin-top: 60px;
}

.fm-spinner {
  width: 44px;
  height: 44px;
  border: 4px solid #FFE0B2;
  border-top-color: var(--fm-accent);
  border-radius: 50%;
  animation: fm-spin 0.8s linear infinite;
}

@keyframes fm-spin {
  to { transform: rotate(360deg); }
}

.fm-loading p {
  font-size: 15px;
  color: var(--fm-text-sub);
}

/* === 에러 카드 === */
.fm-error-card {
  background: var(--fm-card);
  border-radius: var(--fm-radius);
  padding: 28px 24px;
  text-align: center;
  box-shadow: var(--fm-shadow);
  max-width: 380px;
  width: 100%;
  margin-top: 32px;
}

.fm-error-icon {
  font-size: 44px;
  display: block;
  margin-bottom: 10px;
}

.fm-error-card p {
  font-size: 14px;
  color: #666;
  margin-bottom: 18px;
  line-height: 1.5;
}

/* === 결과 섹션: 좌(회원카드) | 우(자녀+버튼) === */
.fm-result-section {
  width: 100%;
  flex: 1 1;
  display: flex;
  gap: 20px;
  align-items: stretch;
  animation: fm-fadeIn 0.35s ease;
}

@keyframes fm-fadeIn {
  from { opacity: 0; transform: translateY(8px); }
  to { opacity: 1; transform: translateY(0); }
}

/* 회원 카드 (좌측) */
.fm-member-card {
  background: var(--fm-card);
  border-radius: var(--fm-radius);
  padding: 16px;
  box-shadow: var(--fm-shadow);
  flex-shrink: 0;
  width: 260px;
  border-left: 4px solid var(--fm-accent);
}

.fm-member-header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 12px;
  padding-bottom: 10px;
  border-bottom: 1.5px solid #FFF3E0;
}

.fm-member-avatar {
  font-size: 28px;
  width: 42px;
  height: 42px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--fm-accent-light);
  border-radius: 50%;
  flex-shrink: 0;
}

.fm-member-name {
  font-family: 'Jua', sans-serif;
  font-size: 18px;
  color: var(--fm-text);
  margin: 0 0 1px;
}

.fm-member-phone {
  font-size: 12px;
  color: var(--fm-text-sub);
}

.fm-member-type-badge {
  margin-left: auto;
  padding: 3px 10px;
  background: var(--fm-accent-light);
  color: var(--fm-accent);
  border: 1px solid #FFE0B2;
  border-radius: 20px;
  font-size: 11px;
  font-weight: 700;
  flex-shrink: 0;
}

.fm-member-stats {
  display: flex;
  gap: 8px;
}

.fm-stat {
  flex: 1 1;
  background: var(--fm-accent-light);
  border-radius: 10px;
  padding: 8px;
  text-align: center;
}

.fm-stat-label {
  display: block;
  font-size: 10px;
  color: var(--fm-text-sub);
  margin-bottom: 2px;
}

.fm-stat-value {
  font-family: 'Jua', sans-serif;
  font-size: 17px;
  color: var(--fm-accent);
}

/* === 우측 영역 (자녀 + 버튼) === */
.fm-right-area {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  gap: 12px;
  justify-content: center;
}

/* 결과 메시지 */
.fm-result-msg {
  padding: 10px 16px;
  border-radius: 10px;
  font-size: 14px;
  font-weight: 600;
  text-align: center;
  animation: fm-fadeIn 0.3s ease;
}

.fm-result-msg.success {
  background: var(--fm-primary-light);
  color: var(--fm-primary);
}

.fm-result-msg.fail {
  background: var(--fm-danger-light);
  color: var(--fm-danger);
}

/* 자녀 목록 */
.fm-children-section {
  background: var(--fm-card);
  border-radius: var(--fm-radius);
  padding: 14px;
  box-shadow: var(--fm-shadow);
}

.fm-section-title {
  font-family: 'Jua', sans-serif;
  font-size: 15px;
  color: var(--fm-text);
  margin: 0 0 10px;
}

.fm-children-list {
  display: flex;
  flex-direction: row;
  gap: 10px;
  overflow-x: auto;
  padding-bottom: 4px;
  justify-content: center;
}

.fm-child-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px 20px;
  background: #FFFDE7;
  border-radius: 14px;
  border: 1.5px solid #FFF9C4;
  flex-shrink: 0;
  min-width: 220px;
  transition: border-color 0.15s;
}

.fm-child-item:hover {
  border-color: var(--fm-gold);
}

.fm-child-avatar {
  width: 46px;
  height: 46px;
  background: linear-gradient(135deg, #FFE082, #FFD54F);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: 'Jua', sans-serif;
  font-size: 20px;
  color: #F57F17;
  flex-shrink: 0;
}

.fm-child-info {
  display: flex;
  flex-direction: column;
  gap: 1px;
}

.fm-child-nickname {
  font-family: 'Jua', sans-serif;
  font-size: 18px;
  color: var(--fm-text);
}

.fm-child-balance {
  font-size: 14px;
  color: var(--fm-text-sub);
}

/* 자녀 편집/삭제 버튼 */
.fm-child-actions {
  display: flex;
  gap: 5px;
  margin-left: auto;
  flex-shrink: 0;
}

.fm-btn-child-edit,
.fm-btn-child-delete {
  width: 40px;
  height: 40px;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  transition: transform 0.12s;
}

.fm-btn-child-edit:active,
.fm-btn-child-delete:active {
  transform: scale(0.9);
}

.fm-btn-child-edit {
  background: var(--fm-edit-blue-light);
}

.fm-btn-child-delete {
  background: var(--fm-danger-light);
}

/* 자녀 인라인 편집 */
.fm-child-edit {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.fm-edit-input {
  padding: 7px 10px;
  border: 2px solid #E0E0E0;
  border-radius: 8px;
  font-size: 14px;
  font-family: 'Noto Sans KR', sans-serif;
  outline: none;
  box-sizing: border-box;
  transition: border-color 0.15s;
}

.fm-edit-input:focus {
  border-color: var(--fm-edit-blue);
}

.fm-edit-buttons {
  display: flex;
  gap: 6px;
}

.fm-btn-edit-save {
  flex: 1 1;
  padding: 7px;
  background: var(--fm-edit-blue);
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
}

.fm-btn-edit-save:disabled {
  opacity: 0.5;
}

.fm-btn-edit-cancel {
  flex: 1 1;
  padding: 7px;
  background: #EEEEEE;
  color: #555;
  border: none;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
}

/* 자녀 추가 폼 */
.fm-add-form {
  background: var(--fm-card);
  border-radius: var(--fm-radius);
  padding: 16px;
  box-shadow: var(--fm-shadow);
  animation: fm-fadeIn 0.3s ease;
}

.fm-form-title {
  font-family: 'Jua', sans-serif;
  font-size: 16px;
  color: var(--fm-text);
  margin: 0 0 12px;
  text-align: center;
}

.fm-form-group {
  margin-bottom: 10px;
}

.fm-form-group label {
  display: block;
  font-size: 12px;
  color: var(--fm-text-sub);
  font-weight: 600;
  margin-bottom: 4px;
}

.fm-form-group input {
  width: 100%;
  padding: 10px 12px;
  border: 2px solid #E0E0E0;
  border-radius: 10px;
  font-size: 15px;
  font-family: 'Noto Sans KR', sans-serif;
  outline: none;
  transition: border-color 0.2s;
  box-sizing: border-box;
}

.fm-form-group input:focus {
  border-color: var(--fm-accent);
}

.fm-form-buttons {
  display: flex;
  gap: 10px;
  margin-top: 12px;
}

.fm-btn-cancel {
  flex: 1 1;
  padding: 12px;
  background: #EEEEEE;
  color: #555;
  border: none;
  border-radius: 10px;
  font-size: 15px;
  font-weight: 700;
  font-family: 'Jua', sans-serif;
  cursor: pointer;
  transition: transform 0.15s;
}

.fm-btn-cancel:active {
  transform: scale(0.97);
}

.fm-btn-confirm {
  flex: 1 1;
  padding: 12px;
  background: var(--fm-accent);
  color: #fff;
  border: none;
  border-radius: 10px;
  font-size: 15px;
  font-weight: 700;
  font-family: 'Jua', sans-serif;
  cursor: pointer;
  transition: transform 0.15s;
  box-shadow: 0 2px 8px rgba(255,152,0,0.25);
}

.fm-btn-confirm:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  box-shadow: none;
}

.fm-btn-confirm:not(:disabled):active {
  transform: scale(0.97);
}

/* 액션 버튼 (좌우 배치) */
.fm-action-buttons-row {
  display: flex;
  gap: 12px;
  justify-content: center;
}

.fm-btn-add-child {
  flex: 1 1;
  padding: 18px;
  background: var(--fm-accent);
  color: #fff;
  border: none;
  border-radius: 12px;
  font-size: 18px;
  font-weight: 700;
  font-family: 'Jua', sans-serif;
  cursor: pointer;
  transition: all 0.15s;
  box-shadow: 0 3px 12px rgba(255,152,0,0.25);
}

.fm-btn-add-child:active {
  transform: scale(0.97);
  box-shadow: 0 1px 6px rgba(255,152,0,0.2);
}

.fm-btn-done {
  flex: 1 1;
  padding: 18px;
  background: var(--fm-primary);
  color: #fff;
  border: none;
  border-radius: 12px;
  font-size: 18px;
  font-weight: 700;
  font-family: 'Jua', sans-serif;
  cursor: pointer;
  transition: all 0.15s;
  box-shadow: 0 3px 12px rgba(46,125,50,0.2);
}

.fm-btn-done:active {
  transform: scale(0.97);
  box-shadow: 0 1px 6px rgba(46,125,50,0.15);
}

.fm-btn-action {
  width: 100%;
  padding: 12px;
  background: var(--fm-primary);
  color: #fff;
  border: none;
  border-radius: 12px;
  font-size: 15px;
  font-weight: 700;
  font-family: 'Jua', sans-serif;
  cursor: pointer;
  transition: transform 0.15s;
}

.fm-btn-action:active {
  transform: scale(0.97);
}

.fm-btn-back-search {
  margin-top: 10px;
}

/* === 신규 가입 확인 === */
.fm-register-section {
  width: 100%;
  max-width: 420px;
  animation: fm-fadeIn 0.3s ease;
}

.fm-register-card {
  background: var(--fm-card);
  border-radius: 18px;
  padding: 28px 24px;
  box-shadow: 0 4px 20px rgba(0,0,0,0.08);
  text-align: center;
  border-top: 4px solid var(--fm-accent);
}

.fm-register-icon {
  font-size: 48px;
  display: block;
  margin-bottom: 10px;
}

.fm-register-title {
  font-family: 'Jua', sans-serif;
  font-size: 20px;
  color: var(--fm-text);
  margin: 0 0 6px;
}

.fm-register-desc {
  font-size: 14px;
  color: #666;
  line-height: 1.6;
  margin: 0 0 16px;
}

.fm-register-phone {
  font-size: 28px;
  font-family: 'Jua', sans-serif;
  font-weight: 700;
  color: var(--fm-accent);
  letter-spacing: 2px;
  padding: 14px;
  background: var(--fm-accent-light);
  border-radius: 14px;
  border: 2px solid #FFE0B2;
  margin-bottom: 16px;
}

.fm-register-buttons {
  display: flex;
  gap: 10px;
  margin-bottom: 4px;
}

.fm-btn-fix-phone {
  flex: 1 1;
  padding: 14px;
  background: var(--fm-accent-light);
  color: #E65100;
  border: 2px solid #FFCC80;
  border-radius: 12px;
  font-size: 16px;
  font-weight: 700;
  font-family: 'Jua', sans-serif;
  cursor: pointer;
  transition: transform 0.15s;
}

.fm-btn-fix-phone:active {
  transform: scale(0.97);
}

.fm-btn-register {
  flex: 1 1;
  padding: 14px;
  background: var(--fm-accent);
  color: #fff;
  border: none;
  border-radius: 12px;
  font-size: 16px;
  font-weight: 700;
  font-family: 'Jua', sans-serif;
  cursor: pointer;
  transition: transform 0.15s;
  box-shadow: 0 2px 8px rgba(255,152,0,0.25);
}

.fm-btn-register:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.fm-btn-register:not(:disabled):active {
  transform: scale(0.97);
}
`, "",{"version":3,"sources":["webpack://./src/pages/FamilyManagePage.css"],"names":[],"mappings":"AAAA;;;EAGE;;AAEF,0BAA0B;AAC1B;EACE,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,2BAA2B;EAC3B,oBAAoB;EACpB,0BAA0B;EAC1B,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,oBAAoB;EACpB,0BAA0B;EAC1B,uBAAuB;EACvB,6BAA6B;EAC7B,iBAAiB;EACjB,wCAAwC;AAC1C;;AAEA,gBAAgB;AAChB;EACE,cAAc;EACd,wBAAwB;EACxB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,uCAAuC;AACzC;;AAEA;;;EAGE,gBAAgB;AAClB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;EACjB,kCAAkC;EAClC,2BAA2B;EAC3B,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,wCAAwC;AAC1C;;AAEA;EACE,8BAA8B;EAC9B,eAAe;EACf,wBAAwB;EACxB,SAAS;AACX;;AAEA;EACE,WAAW;AACb;;AAEA,gBAAgB;AAChB;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,iCAAiC;AACjC;EACE,WAAW;EACX,SAAO;EACP,aAAa;EACb,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,8BAA8B;EAC9B,eAAe;EACf,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA,YAAY;AACZ;EACE,SAAO;EACP,0BAA0B;EAC1B,+BAA+B;EAC/B,aAAa;EACb,4BAA4B;EAC5B,yBAAyB;EACzB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,8BAA8B;EAC9B,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,SAAS;AACT;EACE,aAAa;EACb,qCAAqC;EACrC,kCAAkC;EAClC,QAAQ;EACR,kBAAkB;EAClB,SAAO;AACT;;AAEA;EACE,UAAU;EACV,eAAe;EACf,8BAA8B;EAC9B,gBAAgB;EAChB,0BAA0B;EAC1B,2BAA2B;EAC3B,mBAAmB;EACnB,eAAe;EACf,qBAAqB;EACrB,wCAAwC;EACxC,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,mCAAmC;EACnC,+BAA+B;EAC/B,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,kCAAkC;EAClC,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,UAAU;AACV;EACE,WAAW;EACX,aAAa;EACb,cAAc;EACd,4BAA4B;EAC5B,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,8BAA8B;EAC9B,eAAe;EACf,qBAAqB;EACrB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,yCAAyC;AAC3C;;AAEA,QAAQ;AACR;EACE,aAAa;AACf;;AAEA,UAAU;AACV;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,0BAA0B;EAC1B,+BAA+B;EAC/B,aAAa;EACb,4BAA4B;EAC5B,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kCAAkC;EAClC,kBAAkB;EAClB,uCAAuC;AACzC;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA;EACE,eAAe;EACf,yBAAyB;AAC3B;;AAEA,kBAAkB;AAClB;EACE,0BAA0B;EAC1B,+BAA+B;EAC/B,kBAAkB;EAClB,kBAAkB;EAClB,4BAA4B;EAC5B,gBAAgB;EAChB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,sCAAsC;AACtC;EACE,WAAW;EACX,SAAO;EACP,aAAa;EACb,SAAS;EACT,oBAAoB;EACpB,+BAA+B;AACjC;;AAEA;EACE,OAAO,UAAU,EAAE,0BAA0B,EAAE;EAC/C,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC7C;;AAEA,eAAe;AACf;EACE,0BAA0B;EAC1B,+BAA+B;EAC/B,aAAa;EACb,4BAA4B;EAC5B,cAAc;EACd,YAAY;EACZ,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,oBAAoB;EACpB,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kCAAkC;EAClC,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,8BAA8B;EAC9B,eAAe;EACf,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,kCAAkC;EAClC,uBAAuB;EACvB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,SAAO;EACP,kCAAkC;EAClC,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;EAC9B,eAAe;EACf,uBAAuB;AACzB;;AAEA,4BAA4B;AAC5B;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,uBAAuB;AACzB;;AAEA,WAAW;AACX;EACE,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,mCAAmC;EACnC,wBAAwB;AAC1B;;AAEA;EACE,kCAAkC;EAClC,uBAAuB;AACzB;;AAEA,UAAU;AACV;EACE,0BAA0B;EAC1B,+BAA+B;EAC/B,aAAa;EACb,4BAA4B;AAC9B;;AAEA;EACE,8BAA8B;EAC9B,eAAe;EACf,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,2BAA2B;EAC3B,cAAc;EACd,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qDAAqD;EACrD,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,8BAA8B;EAC9B,eAAe;EACf,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,8BAA8B;EAC9B,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,yBAAyB;AAC3B;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,QAAQ;EACR,iBAAiB;EACjB,cAAc;AAChB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,2BAA2B;AAC7B;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,kCAAkC;AACpC;;AAEA,cAAc;AACd;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,uCAAuC;EACvC,aAAa;EACb,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,+BAA+B;EAC/B,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA,YAAY;AACZ;EACE,0BAA0B;EAC1B,+BAA+B;EAC/B,aAAa;EACb,4BAA4B;EAC5B,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;EAC9B,eAAe;EACf,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,uCAAuC;EACvC,aAAa;EACb,6BAA6B;EAC7B,sBAAsB;AACxB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,8BAA8B;EAC9B,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,4BAA4B;EAC5B,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,8BAA8B;EAC9B,eAAe;EACf,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,4BAA4B;EAC5B,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,8BAA8B;EAC9B,eAAe;EACf,qBAAqB;EACrB,2CAA2C;AAC7C;;AAEA;EACE,sBAAsB;EACtB,yCAAyC;AAC3C;;AAEA;EACE,SAAO;EACP,aAAa;EACb,6BAA6B;EAC7B,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,8BAA8B;EAC9B,eAAe;EACf,qBAAqB;EACrB,0CAA0C;AAC5C;;AAEA;EACE,sBAAsB;EACtB,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,aAAa;EACb,6BAA6B;EAC7B,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,8BAA8B;EAC9B,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,qBAAqB;AACrB;EACE,WAAW;EACX,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,kBAAkB;EAClB,uCAAuC;EACvC,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,eAAe;EACf,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,8BAA8B;EAC9B,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,kCAAkC;EAClC,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,kCAAkC;EAClC,cAAc;EACd,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,8BAA8B;EAC9B,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,4BAA4B;EAC5B,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,8BAA8B;EAC9B,eAAe;EACf,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB","sourcesContent":["/**\n * 가족 정보 변경 - Safari Adventure 태블릿 가로 모드\n * 주렁주렁 세계관 반영: 따뜻한 크림 배경 + 사파리 액센트\n */\n\n/* === CSS Variables === */\n:root {\n  --fm-bg: #FFF8E1;\n  --fm-card: #fff;\n  --fm-primary: #2E7D32;\n  --fm-primary-light: #E8F5E9;\n  --fm-accent: #FF9800;\n  --fm-accent-light: #FFF3E0;\n  --fm-gold: #FFB300;\n  --fm-text: #333;\n  --fm-text-sub: #777;\n  --fm-danger: #D32F2F;\n  --fm-danger-light: #FFEBEE;\n  --fm-edit-blue: #1E88E5;\n  --fm-edit-blue-light: #E3F2FD;\n  --fm-radius: 14px;\n  --fm-shadow: 0 2px 12px rgba(0,0,0,0.07);\n}\n\n/* === 페이지 === */\n.fm-page {\n  height: 100dvh;\n  background: var(--fm-bg);\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  font-family: 'Noto Sans KR', sans-serif;\n}\n\n.fm-page button,\n.fm-page input,\n.fm-page select {\n  min-height: auto;\n}\n\n/* === 헤더 === */\n.fm-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 8px 20px;\n  background: rgba(255,255,255,0.92);\n  backdrop-filter: blur(10px);\n  border-bottom: 2px solid #FFE0B2;\n  flex-shrink: 0;\n}\n\n.fm-header .btn-back {\n  background: none;\n  border: 2px solid #FF9800;\n  color: #E65100;\n  padding: 6px 14px;\n  border-radius: 20px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  white-space: nowrap;\n}\n\n.fm-header .btn-back:active {\n  background: #FFF3E0;\n}\n\n.fm-header-center {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  cursor: pointer;\n  user-select: none;\n  -webkit-tap-highlight-color: transparent;\n}\n\n.fm-header h1 {\n  font-family: 'Jua', sans-serif;\n  font-size: 22px;\n  color: var(--fm-primary);\n  margin: 0;\n}\n\n.fm-header-spacer {\n  width: 72px;\n}\n\n/* === 콘텐츠 === */\n.fm-content {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 12px 24px;\n  overflow-y: auto;\n}\n\n/* === 검색 섹션: 좌우 배치, 높이 채우기 === */\n.fm-search-section {\n  width: 100%;\n  flex: 1;\n  display: flex;\n  gap: 20px;\n  align-items: stretch;\n}\n\n.fm-search-label {\n  font-family: 'Jua', sans-serif;\n  font-size: 15px;\n  color: var(--fm-accent);\n  margin: 0 0 8px;\n  text-align: center;\n  letter-spacing: 0.5px;\n}\n\n/* 전화번호 검색 */\n.fm-phone-search {\n  flex: 1;\n  background: var(--fm-card);\n  border-radius: var(--fm-radius);\n  padding: 16px;\n  box-shadow: var(--fm-shadow);\n  border: 1px solid #FFE0B2;\n  display: flex;\n  flex-direction: column;\n}\n\n.fm-phone-display {\n  padding: 10px;\n  background: var(--fm-accent-light);\n  border: 2px solid #FFE0B2;\n  border-radius: 10px;\n  font-size: 22px;\n  font-family: 'Jua', sans-serif;\n  font-weight: 600;\n  text-align: center;\n  letter-spacing: 3px;\n  color: var(--fm-text);\n  margin-bottom: 8px;\n}\n\n.fm-phone-display:empty,\n.fm-phone-display:not(:empty) {\n  color: var(--fm-text);\n}\n\n.fm-phone-search .fm-phone-display {\n  color: var(--fm-text);\n}\n\n.fm-phone-error {\n  text-align: center;\n  color: var(--fm-danger);\n  font-size: 13px;\n  font-weight: 600;\n  margin-bottom: 6px;\n}\n\n/* 넘버패드 */\n.fm-numpad {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  grid-template-rows: repeat(4, 1fr);\n  gap: 5px;\n  margin-bottom: 8px;\n  flex: 1;\n}\n\n.fm-numpad-btn {\n  padding: 0;\n  font-size: 22px;\n  font-family: 'Jua', sans-serif;\n  font-weight: 600;\n  background: var(--fm-card);\n  border: 1.5px solid #E0E0E0;\n  border-radius: 10px;\n  cursor: pointer;\n  transition: all 0.12s;\n  -webkit-tap-highlight-color: transparent;\n  user-select: none;\n}\n\n.fm-numpad-btn:active {\n  background: var(--fm-primary-light);\n  border-color: var(--fm-primary);\n  transform: scale(0.95);\n}\n\n.fm-numpad-clear {\n  font-size: 12px;\n  font-weight: 600;\n  color: var(--fm-danger);\n  background: var(--fm-danger-light);\n  border-color: #EF9A9A;\n}\n\n.fm-numpad-clear:active {\n  background: #FFCDD2;\n  border-color: #E57373;\n}\n\n.fm-numpad-backspace {\n  font-size: 20px;\n  color: #666;\n  background: #F5F5F5;\n  border-color: #BDBDBD;\n}\n\n.fm-numpad-backspace:active {\n  background: #E0E0E0;\n}\n\n/* 검색 버튼 */\n.fm-phone-btn {\n  width: 100%;\n  padding: 14px;\n  flex-shrink: 0;\n  background: var(--fm-accent);\n  color: #fff;\n  border: none;\n  border-radius: 10px;\n  font-size: 17px;\n  font-weight: 700;\n  font-family: 'Jua', sans-serif;\n  cursor: pointer;\n  transition: all 0.15s;\n  box-shadow: 0 2px 8px rgba(255,152,0,0.3);\n}\n\n.fm-phone-btn:disabled {\n  opacity: 0.35;\n  cursor: not-allowed;\n  box-shadow: none;\n}\n\n.fm-phone-btn:not(:disabled):active {\n  transform: scale(0.97);\n  box-shadow: 0 1px 4px rgba(255,152,0,0.3);\n}\n\n/* 구분선 */\n.fm-divider {\n  display: none;\n}\n\n/* QR 섹션 */\n.fm-qr-section {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  background: var(--fm-card);\n  border-radius: var(--fm-radius);\n  padding: 14px;\n  box-shadow: var(--fm-shadow);\n  border: 1px solid #FFE0B2;\n}\n\n.fm-qr-section .qr-scanner {\n  max-width: 100%;\n  width: 100%;\n}\n\n.fm-qr-section .qr-scanner-viewport {\n  aspect-ratio: 1;\n}\n\n/* === 로딩 === */\n.fm-loading {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 14px;\n  margin-top: 60px;\n}\n\n.fm-spinner {\n  width: 44px;\n  height: 44px;\n  border: 4px solid #FFE0B2;\n  border-top-color: var(--fm-accent);\n  border-radius: 50%;\n  animation: fm-spin 0.8s linear infinite;\n}\n\n@keyframes fm-spin {\n  to { transform: rotate(360deg); }\n}\n\n.fm-loading p {\n  font-size: 15px;\n  color: var(--fm-text-sub);\n}\n\n/* === 에러 카드 === */\n.fm-error-card {\n  background: var(--fm-card);\n  border-radius: var(--fm-radius);\n  padding: 28px 24px;\n  text-align: center;\n  box-shadow: var(--fm-shadow);\n  max-width: 380px;\n  width: 100%;\n  margin-top: 32px;\n}\n\n.fm-error-icon {\n  font-size: 44px;\n  display: block;\n  margin-bottom: 10px;\n}\n\n.fm-error-card p {\n  font-size: 14px;\n  color: #666;\n  margin-bottom: 18px;\n  line-height: 1.5;\n}\n\n/* === 결과 섹션: 좌(회원카드) | 우(자녀+버튼) === */\n.fm-result-section {\n  width: 100%;\n  flex: 1;\n  display: flex;\n  gap: 20px;\n  align-items: stretch;\n  animation: fm-fadeIn 0.35s ease;\n}\n\n@keyframes fm-fadeIn {\n  from { opacity: 0; transform: translateY(8px); }\n  to { opacity: 1; transform: translateY(0); }\n}\n\n/* 회원 카드 (좌측) */\n.fm-member-card {\n  background: var(--fm-card);\n  border-radius: var(--fm-radius);\n  padding: 16px;\n  box-shadow: var(--fm-shadow);\n  flex-shrink: 0;\n  width: 260px;\n  border-left: 4px solid var(--fm-accent);\n}\n\n.fm-member-header {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-bottom: 12px;\n  padding-bottom: 10px;\n  border-bottom: 1.5px solid #FFF3E0;\n}\n\n.fm-member-avatar {\n  font-size: 28px;\n  width: 42px;\n  height: 42px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: var(--fm-accent-light);\n  border-radius: 50%;\n  flex-shrink: 0;\n}\n\n.fm-member-name {\n  font-family: 'Jua', sans-serif;\n  font-size: 18px;\n  color: var(--fm-text);\n  margin: 0 0 1px;\n}\n\n.fm-member-phone {\n  font-size: 12px;\n  color: var(--fm-text-sub);\n}\n\n.fm-member-type-badge {\n  margin-left: auto;\n  padding: 3px 10px;\n  background: var(--fm-accent-light);\n  color: var(--fm-accent);\n  border: 1px solid #FFE0B2;\n  border-radius: 20px;\n  font-size: 11px;\n  font-weight: 700;\n  flex-shrink: 0;\n}\n\n.fm-member-stats {\n  display: flex;\n  gap: 8px;\n}\n\n.fm-stat {\n  flex: 1;\n  background: var(--fm-accent-light);\n  border-radius: 10px;\n  padding: 8px;\n  text-align: center;\n}\n\n.fm-stat-label {\n  display: block;\n  font-size: 10px;\n  color: var(--fm-text-sub);\n  margin-bottom: 2px;\n}\n\n.fm-stat-value {\n  font-family: 'Jua', sans-serif;\n  font-size: 17px;\n  color: var(--fm-accent);\n}\n\n/* === 우측 영역 (자녀 + 버튼) === */\n.fm-right-area {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  justify-content: center;\n}\n\n/* 결과 메시지 */\n.fm-result-msg {\n  padding: 10px 16px;\n  border-radius: 10px;\n  font-size: 14px;\n  font-weight: 600;\n  text-align: center;\n  animation: fm-fadeIn 0.3s ease;\n}\n\n.fm-result-msg.success {\n  background: var(--fm-primary-light);\n  color: var(--fm-primary);\n}\n\n.fm-result-msg.fail {\n  background: var(--fm-danger-light);\n  color: var(--fm-danger);\n}\n\n/* 자녀 목록 */\n.fm-children-section {\n  background: var(--fm-card);\n  border-radius: var(--fm-radius);\n  padding: 14px;\n  box-shadow: var(--fm-shadow);\n}\n\n.fm-section-title {\n  font-family: 'Jua', sans-serif;\n  font-size: 15px;\n  color: var(--fm-text);\n  margin: 0 0 10px;\n}\n\n.fm-children-list {\n  display: flex;\n  flex-direction: row;\n  gap: 10px;\n  overflow-x: auto;\n  padding-bottom: 4px;\n  justify-content: center;\n}\n\n.fm-child-item {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 16px 20px;\n  background: #FFFDE7;\n  border-radius: 14px;\n  border: 1.5px solid #FFF9C4;\n  flex-shrink: 0;\n  min-width: 220px;\n  transition: border-color 0.15s;\n}\n\n.fm-child-item:hover {\n  border-color: var(--fm-gold);\n}\n\n.fm-child-avatar {\n  width: 46px;\n  height: 46px;\n  background: linear-gradient(135deg, #FFE082, #FFD54F);\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-family: 'Jua', sans-serif;\n  font-size: 20px;\n  color: #F57F17;\n  flex-shrink: 0;\n}\n\n.fm-child-info {\n  display: flex;\n  flex-direction: column;\n  gap: 1px;\n}\n\n.fm-child-nickname {\n  font-family: 'Jua', sans-serif;\n  font-size: 18px;\n  color: var(--fm-text);\n}\n\n.fm-child-balance {\n  font-size: 14px;\n  color: var(--fm-text-sub);\n}\n\n/* 자녀 편집/삭제 버튼 */\n.fm-child-actions {\n  display: flex;\n  gap: 5px;\n  margin-left: auto;\n  flex-shrink: 0;\n}\n\n.fm-btn-child-edit,\n.fm-btn-child-delete {\n  width: 40px;\n  height: 40px;\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n  font-size: 15px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0;\n  transition: transform 0.12s;\n}\n\n.fm-btn-child-edit:active,\n.fm-btn-child-delete:active {\n  transform: scale(0.9);\n}\n\n.fm-btn-child-edit {\n  background: var(--fm-edit-blue-light);\n}\n\n.fm-btn-child-delete {\n  background: var(--fm-danger-light);\n}\n\n/* 자녀 인라인 편집 */\n.fm-child-edit {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.fm-edit-input {\n  padding: 7px 10px;\n  border: 2px solid #E0E0E0;\n  border-radius: 8px;\n  font-size: 14px;\n  font-family: 'Noto Sans KR', sans-serif;\n  outline: none;\n  box-sizing: border-box;\n  transition: border-color 0.15s;\n}\n\n.fm-edit-input:focus {\n  border-color: var(--fm-edit-blue);\n}\n\n.fm-edit-buttons {\n  display: flex;\n  gap: 6px;\n}\n\n.fm-btn-edit-save {\n  flex: 1;\n  padding: 7px;\n  background: var(--fm-edit-blue);\n  color: white;\n  border: none;\n  border-radius: 8px;\n  font-size: 13px;\n  font-weight: 700;\n  cursor: pointer;\n}\n\n.fm-btn-edit-save:disabled {\n  opacity: 0.5;\n}\n\n.fm-btn-edit-cancel {\n  flex: 1;\n  padding: 7px;\n  background: #EEEEEE;\n  color: #555;\n  border: none;\n  border-radius: 8px;\n  font-size: 13px;\n  font-weight: 700;\n  cursor: pointer;\n}\n\n/* 자녀 추가 폼 */\n.fm-add-form {\n  background: var(--fm-card);\n  border-radius: var(--fm-radius);\n  padding: 16px;\n  box-shadow: var(--fm-shadow);\n  animation: fm-fadeIn 0.3s ease;\n}\n\n.fm-form-title {\n  font-family: 'Jua', sans-serif;\n  font-size: 16px;\n  color: var(--fm-text);\n  margin: 0 0 12px;\n  text-align: center;\n}\n\n.fm-form-group {\n  margin-bottom: 10px;\n}\n\n.fm-form-group label {\n  display: block;\n  font-size: 12px;\n  color: var(--fm-text-sub);\n  font-weight: 600;\n  margin-bottom: 4px;\n}\n\n.fm-form-group input {\n  width: 100%;\n  padding: 10px 12px;\n  border: 2px solid #E0E0E0;\n  border-radius: 10px;\n  font-size: 15px;\n  font-family: 'Noto Sans KR', sans-serif;\n  outline: none;\n  transition: border-color 0.2s;\n  box-sizing: border-box;\n}\n\n.fm-form-group input:focus {\n  border-color: var(--fm-accent);\n}\n\n.fm-form-buttons {\n  display: flex;\n  gap: 10px;\n  margin-top: 12px;\n}\n\n.fm-btn-cancel {\n  flex: 1;\n  padding: 12px;\n  background: #EEEEEE;\n  color: #555;\n  border: none;\n  border-radius: 10px;\n  font-size: 15px;\n  font-weight: 700;\n  font-family: 'Jua', sans-serif;\n  cursor: pointer;\n  transition: transform 0.15s;\n}\n\n.fm-btn-cancel:active {\n  transform: scale(0.97);\n}\n\n.fm-btn-confirm {\n  flex: 1;\n  padding: 12px;\n  background: var(--fm-accent);\n  color: #fff;\n  border: none;\n  border-radius: 10px;\n  font-size: 15px;\n  font-weight: 700;\n  font-family: 'Jua', sans-serif;\n  cursor: pointer;\n  transition: transform 0.15s;\n  box-shadow: 0 2px 8px rgba(255,152,0,0.25);\n}\n\n.fm-btn-confirm:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n  box-shadow: none;\n}\n\n.fm-btn-confirm:not(:disabled):active {\n  transform: scale(0.97);\n}\n\n/* 액션 버튼 (좌우 배치) */\n.fm-action-buttons-row {\n  display: flex;\n  gap: 12px;\n  justify-content: center;\n}\n\n.fm-btn-add-child {\n  flex: 1;\n  padding: 18px;\n  background: var(--fm-accent);\n  color: #fff;\n  border: none;\n  border-radius: 12px;\n  font-size: 18px;\n  font-weight: 700;\n  font-family: 'Jua', sans-serif;\n  cursor: pointer;\n  transition: all 0.15s;\n  box-shadow: 0 3px 12px rgba(255,152,0,0.25);\n}\n\n.fm-btn-add-child:active {\n  transform: scale(0.97);\n  box-shadow: 0 1px 6px rgba(255,152,0,0.2);\n}\n\n.fm-btn-done {\n  flex: 1;\n  padding: 18px;\n  background: var(--fm-primary);\n  color: #fff;\n  border: none;\n  border-radius: 12px;\n  font-size: 18px;\n  font-weight: 700;\n  font-family: 'Jua', sans-serif;\n  cursor: pointer;\n  transition: all 0.15s;\n  box-shadow: 0 3px 12px rgba(46,125,50,0.2);\n}\n\n.fm-btn-done:active {\n  transform: scale(0.97);\n  box-shadow: 0 1px 6px rgba(46,125,50,0.15);\n}\n\n.fm-btn-action {\n  width: 100%;\n  padding: 12px;\n  background: var(--fm-primary);\n  color: #fff;\n  border: none;\n  border-radius: 12px;\n  font-size: 15px;\n  font-weight: 700;\n  font-family: 'Jua', sans-serif;\n  cursor: pointer;\n  transition: transform 0.15s;\n}\n\n.fm-btn-action:active {\n  transform: scale(0.97);\n}\n\n.fm-btn-back-search {\n  margin-top: 10px;\n}\n\n/* === 신규 가입 확인 === */\n.fm-register-section {\n  width: 100%;\n  max-width: 420px;\n  animation: fm-fadeIn 0.3s ease;\n}\n\n.fm-register-card {\n  background: var(--fm-card);\n  border-radius: 18px;\n  padding: 28px 24px;\n  box-shadow: 0 4px 20px rgba(0,0,0,0.08);\n  text-align: center;\n  border-top: 4px solid var(--fm-accent);\n}\n\n.fm-register-icon {\n  font-size: 48px;\n  display: block;\n  margin-bottom: 10px;\n}\n\n.fm-register-title {\n  font-family: 'Jua', sans-serif;\n  font-size: 20px;\n  color: var(--fm-text);\n  margin: 0 0 6px;\n}\n\n.fm-register-desc {\n  font-size: 14px;\n  color: #666;\n  line-height: 1.6;\n  margin: 0 0 16px;\n}\n\n.fm-register-phone {\n  font-size: 28px;\n  font-family: 'Jua', sans-serif;\n  font-weight: 700;\n  color: var(--fm-accent);\n  letter-spacing: 2px;\n  padding: 14px;\n  background: var(--fm-accent-light);\n  border-radius: 14px;\n  border: 2px solid #FFE0B2;\n  margin-bottom: 16px;\n}\n\n.fm-register-buttons {\n  display: flex;\n  gap: 10px;\n  margin-bottom: 4px;\n}\n\n.fm-btn-fix-phone {\n  flex: 1;\n  padding: 14px;\n  background: var(--fm-accent-light);\n  color: #E65100;\n  border: 2px solid #FFCC80;\n  border-radius: 12px;\n  font-size: 16px;\n  font-weight: 700;\n  font-family: 'Jua', sans-serif;\n  cursor: pointer;\n  transition: transform 0.15s;\n}\n\n.fm-btn-fix-phone:active {\n  transform: scale(0.97);\n}\n\n.fm-btn-register {\n  flex: 1;\n  padding: 14px;\n  background: var(--fm-accent);\n  color: #fff;\n  border: none;\n  border-radius: 12px;\n  font-size: 16px;\n  font-weight: 700;\n  font-family: 'Jua', sans-serif;\n  cursor: pointer;\n  transition: transform 0.15s;\n  box-shadow: 0 2px 8px rgba(255,152,0,0.25);\n}\n\n.fm-btn-register:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.fm-btn-register:not(:disabled):active {\n  transform: scale(0.97);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
